import { render, staticRenderFns } from "./ListQuotes.vue?vue&type=template&id=67f2c649"
import script from "./ListQuotes.vue?vue&type=script&lang=js"
export * from "./ListQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListQuotes.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f2c649')) {
      api.createRecord('67f2c649', component.options)
    } else {
      api.reload('67f2c649', component.options)
    }
    module.hot.accept("./ListQuotes.vue?vue&type=template&id=67f2c649", function () {
      api.rerender('67f2c649', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ListQuotes.vue"
export default component.exports